export const CHROME_EXTENSION_ID = 'cjmjnmmcpaaclkadamieohplibjjldid';

export const CHROME_STORE_URL = `https://chromewebstore.google.com/detail/${CHROME_EXTENSION_ID}`;

export const getChromeStoreUrl = (utmCampaign?: string): string => {
  const params = new URLSearchParams({
    utm_source: 'govtoolspro',
    utm_medium: 'website',
    utm_campaign: utmCampaign || 'landing'
  });
  return `${CHROME_STORE_URL}?${params.toString()}`;
};
